export default __webpack_public_path__ + "static/media/produto-bananinha.075e3fcc.png";